<template>
  <div>
    <Navbar />
    <v-main>
      <v-sheet
        max-width="1000"
        class="mx-auto pa-3 pa-md-12 mt-3 mt-md-12 mb-12"
      >
        <router-view />
      </v-sheet>
    </v-main>
    <PanierDrawer v-if="$route.name !== 'Caisse'" />
  </div>
</template>

<script>
import Navbar from "@/components/boutique/Navbar";
import PanierDrawer from "@/components/boutique/PanierDrawer";
import { mapActions } from "vuex";
export default {
  components: {
    Navbar,
    PanierDrawer,
  },
  props: {
    hidePanierDrawer: Boolean,
  },
  methods: {
    ...mapActions(["LOAD_FROM_LOCAL_STORAGE"]),
  },
  mounted() {
    this.LOAD_FROM_LOCAL_STORAGE();
  },
};
</script>

<style scoped>
</style>